module.exports = __WEBPACK_EXTERNAL_MODULE_45__;


//////////////////
// WEBPACK FOOTER
// external "fenix-ui-bridge"
// module id = 45
// module chunks = 0